import { userConstants } from '../_constants';
import { userService } from '../_services';
import { history } from '../_helpers';
import { forgotPinEffect } from '../_effects';
import { alertActions } from './alertActions';

export const forgotPinActions = {
  forgotPin,
  clearMsg,
};

function clearMsg() {
  return (dispatch) => {
    dispatch(clearMpinMsg());
  };
}

function clearMpinMsg() {
  return { type: userConstants.RESET_MSG, payload: null };
}

function forgotPin(mpin) {
  return (dispatch) => {
    dispatch(request(mpin));
    forgotPinEffect.forgotPinSet(mpin).then(
      (res) => {
        dispatch(success(res));
        if (res.data.statusCode === '200') {
          history.push('/reset-pin');
        } else {
          history.push('./forgot-pin');
        }
      },
      (error) => {
        console.log('action mpin error', error);
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(mpin) {
    return { type: userConstants.FORGOTPIN_REQUEST, mpin };
  }
  function success(mpin) {
    return { type: userConstants.FORGOTPIN_SUCCESS, mpin };
  }
  function failure(error) {
    return { type: userConstants.FORGOTPIN_FAILURE, error };
  }
}
